import BackgroundMap from './BackgroundMap';

export default BackgroundMap;
